export const CardShimmer = ({ length = 8 }: { length?: number }) => {
  return (
    <div>
      <div className="space-y-4">
        {Array.from({ length: length || 8 }).map((_, idx) => (
          <div
            key={idx}
            className="p-4 border border-gray-200 rounded-lg shadow-md bg-white"
          >
            <div className="space-y-2">
              {/* Customer Name */}
              <div className="h-4 bg-gray-200 rounded w-48 animate-pulse"></div>
              {/* Status */}
              <div className="h-4 bg-gray-200 rounded w-32 animate-pulse"></div>
              {/* Buttons */}
              <div className="flex gap-4 mt-4">
                <div className="h-8 w-20 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-8 w-20 bg-gray-200 rounded animate-pulse"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const TableShimmer = () => {
  return (
    <div>
      <div className="overflow-hidden rounded-lg shadow-lg border border-gray-200">
        {/* Header */}
        <div className="bg-blue-100 px-4 py-2 h-12 items-center grid">
          <div className="grid grid-cols-4 gap-4">
            <div className="h-4 bg-gray-300 rounded w-24"></div>
            <div className="h-4 bg-gray-300 rounded w-36"></div>
            <div className="h-4 bg-gray-300 rounded w-20"></div>
            <div className="h-4 bg-gray-300 rounded w-24"></div>
          </div>
        </div>
        {/* Rows */}
        <div className="divide-y divide-gray-200">
          {Array.from({ length: 5 }).map((_, idx) => (
            <div key={idx} className="grid grid-cols-4 gap-4 p-4 items-center">
              <div className="h-4 bg-gray-200 rounded w-28 animate-pulse"></div>
              <div className="h-4 bg-gray-200 rounded w-36 animate-pulse"></div>
              <div className="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
              <div className="flex gap-2">
                <div className="h-8 w-16 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-8 w-16 bg-gray-200 rounded animate-pulse"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TableShimmer;
